import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../../../App/store';
import { CommonStudyMode } from '../../../../Common/entities';
import { mapApProgramDetailsAvailableStatus } from '../../mappers';
import { getAPLearnModeTimeSpentSecondsByCourseId } from '../../utils';
import { AP_SLICE_NAME, setApLearnModeTimeSpentSeconds } from '../APSlice';

import { recordApProgramTimeSpent } from './RecordApProgramTimeSpentAction';

export const finalizeApLearnModeTimeSpent = createAsyncThunk(
  `${AP_SLICE_NAME}/finalizeApLearnModeTimeSpent`,
  async (courseId: string, thunkAPI) => {
    const rootState = thunkAPI.getState() as RootState;
    const isProgramAvailable = mapApProgramDetailsAvailableStatus(rootState);

    if (!isProgramAvailable) {
      return;
    }

    const timeSpentSeconds = getAPLearnModeTimeSpentSecondsByCourseId(courseId);
    if (!timeSpentSeconds || !courseId) {
      return;
    }

    const timeSpentMinutes = Math.floor(timeSpentSeconds / 60);
    if (timeSpentMinutes > 0) {
      thunkAPI.dispatch(
        recordApProgramTimeSpent({
          courseId,
          timeSpentMinutes,
          studyMode: CommonStudyMode.LEARN,
        }),
      );

      thunkAPI.dispatch(
        setApLearnModeTimeSpentSeconds({
          courseId,
          timeSpentSeconds: 0,
        }),
      );
    }
  },
);
